export const CUSTOMERS_LIST = "CUSTOMERS_LIST";
